import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchChangePurchaserLists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/change-purchaser/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
